import { isServer } from '@helpers/env';

import { MILLISECONDS_IN_DAY } from '@constants/time';

export const getClientCookies = (name: string) => {
    if (isServer()) {
        return undefined;
    } else {
        return document.cookie.split('; ').reduce((r, v) => {
            const parts = v.split('=');
            return parts[0] === name ? decodeURIComponent(parts[1] ?? '') : r;
        }, '');
    }
};

export const setClientCookie = (name: string, value: string, days?: number): void => {
    if (!isServer()) {
        let cookieString = `${name}=${encodeURIComponent(value)};path=/`;
        if (days !== undefined) {
            const expires = new Date();
            expires.setTime(expires.getTime() + days * MILLISECONDS_IN_DAY);
            cookieString += `;expires=${expires.toUTCString()}`;
        }
        document.cookie = cookieString;
    }
};

export const deleteClientCookie = (name: string): void => {
    if (!isServer()) {
        document.cookie = `${name}=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    }
};
